module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3714d94dcb0a446129bc03d427731b5d.gif";